var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 1.16666C5.76279 1.16805 4.57661 1.66016 3.70174 2.53503C2.82688 3.40989 2.33476 4.59607 2.33337 5.83332C2.33337 7.73207 3.71179 9.30882 5.17187 10.9777C5.63387 11.5062 6.11221 12.0528 6.53804 12.6058C6.59253 12.6765 6.66252 12.7338 6.74262 12.7731C6.82272 12.8125 6.91078 12.833 7.00004 12.833C7.0893 12.833 7.17737 12.8125 7.25746 12.7731C7.33756 12.7338 7.40755 12.6765 7.46204 12.6058C7.88787 12.0528 8.36621 11.5062 8.82821 10.9777C10.2883 9.30882 11.6667 7.73207 11.6667 5.83332C11.6653 4.59607 11.1732 3.40989 10.2983 2.53503C9.42347 1.66016 8.23729 1.16805 7.00004 1.16666ZM7.00004 7.58332C6.65392 7.58332 6.31558 7.48069 6.02779 7.2884C5.74001 7.0961 5.5157 6.82279 5.38325 6.50302C5.2508 6.18325 5.21614 5.83138 5.28367 5.49192C5.35119 5.15245 5.51786 4.84063 5.7626 4.59589C6.00735 4.35114 6.31917 4.18447 6.65863 4.11695C6.9981 4.04943 7.34997 4.08408 7.66974 4.21653C7.98951 4.34899 8.26282 4.57329 8.45511 4.86108C8.64741 5.14886 8.75004 5.48721 8.75004 5.83332C8.75004 6.29745 8.56567 6.74257 8.23748 7.07076C7.90929 7.39895 7.46417 7.58332 7.00004 7.58332Z",
    fill: "#1C75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.02860472d26b2c7eda9651d3d07ea165.svg";
export { ForwardRef as ReactComponent };